import store from 'redux/store';
import { getCourseCompletionProgress, updateTimeline } from 'redux/actions/timeline';

class ReactTimelineService {
  updateTimeline(lecturePageId: number, isEditMode = false) {
    const state = store.getState();
    const catalogId = state.models.lecturePages[lecturePageId]?.course?.catalogId;
    const inArchiveMode = state.models.lecturePages[lecturePageId]?.course?.inArchiveMode;
    store.dispatch(updateTimeline({ lecturePageId, isEditMode }));
    if (!isEditMode && catalogId && !inArchiveMode) {
      store.dispatch(getCourseCompletionProgress({ catalogId }));
    }
  }
}

const ReactTimelineServiceSingleton = new ReactTimelineService();

export default ReactTimelineServiceSingleton;

export const useTimelineService = () => ReactTimelineServiceSingleton;
